var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"addFromAdmin"},[_c('table-list',{attrs:{"loading":_vm.loading,"title":_vm.$route.meta.title,"data":_vm.adminList,"search-form":_vm.searchForm(this),"columns":_vm.columns(this),"btns":_vm.btns(this),"options":{ selection: true }},on:{"search":_vm.onSearch,"selectionChange":_vm.handleSelectionChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }